export const contactNumber = "60142655705";
export const callLink = `tel:+${contactNumber}`;
export const whatsappLink = `https://wa.me/${contactNumber}?text=Hi,%20saw%20your%20ads%20on%20google.%20I%20need%20to%20repair%20my`;
